export const SPA_INITIAL_PAGE_SIZE = 5;
export const SSR_INITIAL_PAGE_SIZE = 5;
export const getInitialPageSize = () =>
	process.env.REACT_SSR || window.__SSR_RENDERED__ ? SSR_INITIAL_PAGE_SIZE : SPA_INITIAL_PAGE_SIZE;
